import React, {useState} from "react";
import "./SoftwareSkill.scss";
import {skillsSection} from "../../portfolio";
import {SiTailwindcss, SiMongodb, SiDjango, SiTypescript} from "react-icons/si";
import {TbBrandNextjs} from "react-icons/tb";

export default function SoftwareSkill() {
  const [isHovered1, setIsHovered1] = useState(false);
  const [isHovered2, setIsHovered2] = useState(false);
  const [isHovered3, setIsHovered3] = useState(false);
  const [isHovered4, setIsHovered4] = useState(false);
  const [isHovered5, setIsHovered5] = useState(false);
  return (
    <div>
      <div className="software-skills-main-div">
        <ul className="dev-icons">
          {skillsSection.softwareSkills.map((skills, i) => {
            return (
              <li
                key={i}
                className="software-skill-inline"
                name={skills.skillName}
              >
                <i className={skills.fontAwesomeClassname}></i>
                <p>{skills.skillName}</p>
              </li>
            );
          })}
          <li className="software-skill-inline">
            <SiTailwindcss
              onMouseEnter={() => setIsHovered1(true)}
              onMouseLeave={() => setIsHovered1(false)}
              color={isHovered1 ? "#645beb" : "#868E96"}
            />
            <p color={"#868E96"}>tailwind css</p>
          </li>
          <li className="software-skill-inline">
            <SiDjango
              onMouseEnter={() => setIsHovered2(true)}
              onMouseLeave={() => setIsHovered2(false)}
              color={isHovered2 ? "#645beb" : "#868E96"}
            />
            <p color={"#868E96"}>django</p>
          </li>
          <li className="software-skill-inline">
            <SiMongodb
              onMouseEnter={() => setIsHovered3(true)}
              onMouseLeave={() => setIsHovered3(false)}
              color={isHovered3 ? "#645beb" : "#868E96"}
            />
            <p color={"#868E96"}>mongodb</p>
          </li>
          <li className="software-skill-inline">
            <SiTypescript
              onMouseEnter={() => setIsHovered4(true)}
              onMouseLeave={() => setIsHovered4(false)}
              color={isHovered4 ? "#645beb" : "#868E96"}
            />
            <p color={"#868E96"}>typescript</p>
          </li>
          <li className="software-skill-inline">
            <TbBrandNextjs
              onMouseEnter={() => setIsHovered5(true)}
              onMouseLeave={() => setIsHovered5(false)}
              color={isHovered5 ? "#645beb" : "#868E96"}
            />
            <p color={"#868E96"}>nextjs</p>
          </li>
        </ul>
      </div>
    </div>
  );
}
